import { createTheme } from "@material-ui/core/styles";
import { color } from "../../helpers/constant";

const theme = createTheme({
    palette: {
        primary: {
            main: color.primary
        },
        darkGrey: {
            main: color.darkGrey
        },
        secondary: {
            main: color.secondary
        },
        background: {
            default: "#FFF"
        }
    },
    typography: {
        fontFamily: "poppins",
        button: {
            textTransform: "capitalize"
        }
    },
    props: {
        MuiButton: {
            size: "medium"
        }
    },
    overrides: {
        MuiButton: {
            containedPrimary: {
                color: "#FFF"
            }
        }
        // MuiTextField: {
        //   size: "small",
        //   fontSize: 7,
        //   variant: "outlined",
        // },
    }
});

export default theme;